module.exports = __webpack_public_path__ + "static/media/golf-carousel-360x640.0a7a3c3f.jpg";